import SimpleStore, { readCookie } from './SimpleStore'

import axios from 'axios'
import i18n from '../i18n'

export default (baseURL: string): void => {
  axios.defaults.baseURL = baseURL
  axios.defaults.withCredentials = true
  axios.defaults.headers.common.Accept = 'application/json'
  axios.defaults.headers.common['Content-Type'] = 'application/json'
  axios.defaults.headers.common['Client-Version'] = 'web version 2.0'
  axios.defaults.headers.common['Accept-Language'] = i18n.getCurrentLanguage()
  let csrfToken = readCookie('csrf_token')

  // add interceptor for CSRF logic to be request based
  axios.interceptors.request.use(
    config => {
      csrfToken = readCookie('csrf_token')
      config.headers['X-CSRFToken'] =
        typeof document !== 'undefined' && csrfToken ? csrfToken : null

      const token = getToken(true)
      if (token && token.length > 0) {
        config.headers.Authorization = token
      }

      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  if (csrfToken) {
    axios.defaults.headers.common['X-CSRFToken'] = decodeURIComponent(
      csrfToken.trim().substring(11)
    )
  }
}

export const getToken = (includePrefix: boolean = false): string => {
  const preferredToken = SimpleStore.get('preferred_token')
  const ddwebToken = readCookie('ddweb_token')
  const token = SimpleStore.get('token')
  if (preferredToken) {
    return preferredToken
  } else if (ddwebToken) {
    const prefix = includePrefix ? 'JWT ' : ''
    return `${prefix}${ddwebToken.split(':')[0]}`
  } else if (token) {
    const prefix = includePrefix ? 'token ' : ''
    return `${prefix}${token}`
  }
  return ""
}


// this is so we can re-configure axios to use a specific token
export const reconfigureApi = (token: string): void => {
  if (token.split(' ').length === 1) {
    SimpleStore.set('preferred_token', `JWT ${token}`)
  } else {
    SimpleStore.set('preferred_token', token)
  }
}
